import React from "react";

const PaperDarkBG = ({ children, className = "", fullHeight = false}) => {
  return (
    <div
      className={`${fullHeight ? "min-h-screen" : ""} w-full text-[#d0cbb8] bg-[#1a1a1a]  ${className}`}
    >
      {children}
    </div>
  );
};

export default PaperDarkBG;
